import type { WorkspaceContext } from '@template-ui/blocks';
import type { CaseContextWorkflowSnapshot } from '@app/case-context/components/case-context-snapshot-rail/case-context-snapshot-rail.component';

/** Editor-only facts; the reused snapshot component performs no reads or navigation in this mode. */
export function caseSnapshotPreview(context: WorkspaceContext): unknown {
  const incarceratedPersonId = 1,
    scheduledProceedingId = 1;
  const snapshot: CaseContextWorkflowSnapshot = {
    demographics: {
      incarceratedPersonId,
      hasData: true,
      age: 43,
      dateOfBirth: '1983-01-01',
      gender: 'Male',
      raceEthnicity: 'Recorded ethnicity',
      languages: 'English, Spanish',
    },
    incarcerationHistory: {
      incarceratedPersonId,
      admitDate: '2013-03-06',
      eligibilityDate: '2027-01-24',
      projectedReleaseDate: '2031-01-18',
      terms: [
        {
          id: 1,
          facilityLabel: 'Example institution',
          securityLevel: 'Level 3',
          eventTypeCode: 'admission',
          startedOn: '2013-03-06',
          isCurrent: true,
          ordinal: 1,
        },
      ],
    },
    hearing: {
      incarceratedPersonId,
      scheduledProceedingId,
      hasHearing: true,
      proceedingTypeCode: 'subsequent-parole-hearing',
      scheduledStartUtc: '2027-03-15T17:00:00Z',
      statusCode: 'scheduled',
      statusLabel: 'Scheduled',
      format: 'Video',
      locationName: 'Example hearing venue',
      requirementsTotal: 0,
      requirementsComplete: 0,
      requirements: [],
      panel: [{ name: 'Example commissioner', isPresiding: true }],
    },
    hearingContext: true,
    canSchedule: false,
  };
  return {
    occurrenceId: context.workflow?.stepOccurrenceId,
    availability: 'available',
    totalCount: 1,
    syntheticPreview: true,
    rows: [
      {
        incarceratedPersonId,
        scheduledProceedingId,
        snapshotJson: JSON.stringify(snapshot),
      },
    ],
  };
}
